export default __webpack_public_path__ + "static/media/ic-next.63905b38.svg";